<div class="dialog-header">
  <div class="dialog-icon-wrapper">
    <div class="dialog-icon new">
      <i class="fa-solid fa-sliders"></i>
    </div>
    <div>
      <h2 class="dialog-title">Filter Creativities</h2>
      <p class="dialog-subtitle">Set criteria to filter results</p>
    </div>
  </div>
  <button class="dialog-close" (click)="onCancel()">
    <i class="fa-solid fa-xmark"></i>
  </button>
</div>

<mat-dialog-content class="dialog-body">
  <form [formGroup]="filtersForm" class="dialog-form-grid">
    <!-- Campaign Title -->
    <div class="dialog-field-group">
      <mat-label class="mat-form-field-label">Campaign Title</mat-label>
      <mat-form-field appearance="outline">
        <input matInput formControlName="campaignTitle" placeholder="Enter campaign title">
      </mat-form-field>
    </div>

    <!-- Brand -->
    <div class="dialog-field-group">
      <mat-label class="mat-form-field-label">Brand</mat-label>
      <mat-form-field appearance="outline">
        <input matInput formControlName="brand" placeholder="Enter brand">
      </mat-form-field>
    </div>

    <!-- Commercial Office -->
    <div class="dialog-field-group">
      <mat-label class="mat-form-field-label">Commercial Office</mat-label>
      <mat-form-field appearance="outline">
        <mat-select formControlName="commercialOffice" placeholder="Select office" multiple [compareWith]="comparatorService.compareById">
          <mat-select-trigger>
            @if (filtersForm.get('commercialOffice')?.value?.length > 0) {
              {{ filtersForm.get('commercialOffice')?.value[0] | objectdesc }}
              @if (filtersForm.get('commercialOffice')?.value?.length > 1) {
                <span class="additional-selection">
                  (+{{ filtersForm.get('commercialOffice')?.value.length - 1 }}
                  {{ filtersForm.get('commercialOffice')?.value.length === 2 ? 'other' : 'others' }})
                </span>
              }
            }
          </mat-select-trigger>
          @for( office of commercialOffices; track office ) {
            <mat-option [value]="office">{{ office | objectdesc}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>

    <!-- Agency -->
    <div class="dialog-field-group">
      <mat-label class="mat-form-field-label">Agency</mat-label>
      <mat-form-field appearance="outline">
        <mat-select formControlName="agency" placeholder="Select agency" multiple [compareWith]="comparatorService.compareById">
          <mat-select-trigger>
            @if (filtersForm.get('agency')?.value?.length > 0) {
              {{ filtersForm.get('agency')?.value[0] | objectdesc }}
              @if (filtersForm.get('agency')?.value?.length > 1) {
                <span class="additional-selection">
                  (+{{ filtersForm.get('agency')?.value.length - 1 }}
                  {{ filtersForm.get('agency')?.value.length === 2 ? 'other' : 'others' }})
                </span>
              }
            }
          </mat-select-trigger>
          @for( agency of agencies; track agency ) {
            <mat-option [value]="agency">{{ agency | objectdesc}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>

    <!-- Reference Code -->
    <div class="dialog-field-group">
      <mat-label class="mat-form-field-label">Reference Code</mat-label>
      <mat-form-field appearance="outline">
        <input matInput formControlName="referenceCode" placeholder="Enter reference code">
      </mat-form-field>
    </div>

    <!-- Original Filename -->
    <div class="dialog-field-group">
      <mat-label class="mat-form-field-label">Original Filename</mat-label>
      <mat-form-field appearance="outline">
        <input matInput formControlName="originalFilename" placeholder="Enter original filename">
      </mat-form-field>
    </div>

    <!-- Created From/To -->
    <div class="dialog-field-group">
      <mat-label class="mat-form-field-label">Created From/To</mat-label>
      <mat-form-field appearance="outline">
        <mat-date-range-input [rangePicker]="picker">
          <input matStartDate formControlName="createdFrom" placeholder="Start date" readonly>
          <input matEndDate formControlName="createdTo" placeholder="End date" readonly>
        </mat-date-range-input>
        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>
      </mat-form-field>
    </div>

    <!-- Result Limit -->
    <div class="dialog-field-group">
      <mat-label class="mat-form-field-label">Result Limit</mat-label>
      <mat-form-field appearance="outline">
        <input matInput type="number" formControlName="resultLimit" placeholder="Enter limit">
      </mat-form-field>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions class="dialog-footer">
  <button class="btn-ghost" (click)="onCancel()">Cancel</button>
  <button class="btn-ghost" (click)="onClear()">Clear Filters</button>
  <button class="btn-blue" (click)="onApply()">Apply Filters</button>
</mat-dialog-actions>

